import type { SavedPresetDTO } from '../api/types';
import type { SavedPresetRecord } from '../model/types';

export const mapSavedPreset = (dto: SavedPresetDTO): SavedPresetRecord => {
  return {
    id: dto.id,
    name: dto.name,
    viewType: dto.viewType,
    preset: dto.preset,
    isDefault: dto.isDefault,
    isFavorite: dto.isFavorite,
    updatedAt: dto.updatedAt,
    updating: false,
  };
};
